import "./App.css";
import {
  Configuration,
  IPublicClientApplication,
  InteractionType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { LicenseInfo } from "@mui/x-license-pro";
import { createBrowserRouter, RouterProvider, Outlet, Navigate, useParams } from "react-router-dom";

import {
  useMsal,
  MsalAuthenticationTemplate,
  MsalProvider,
} from "@azure/msal-react";
import React, { useState, useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "./redux/hooks";
import useConfig from "hooks/common-hooks";
import { SessionTimeoutPopup } from "notification/sessionTimeoutPopup";
import Footer from "layout/Footer";
import Header from "layout/Header";
import { getUserData } from "./redux/slices/userContextSlice";
import LeaseForm from "components/lease/Forms/LeaseForm";
import DashboardDataGrid from "components/Dashboard/DashboardDataGrid";
import UserRoleMapForm from "components/settings/user-role-map/UserRoleMapForm";
import UserRoleMapDashboard from "components/settings/user-role-map/UserRoleMapDashboard";
import Rawdata from "components/settings/raw-data/raw-data";


LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENCE_KEY as string);

const AuthProvider = (props: any) => {
  console.log("Inside App.tsx before useConfig");
  const [config] = useConfig();
  console.log("Inside App.tsx after useConfig");

  if (!config?.msalConfig?.auth) return <>Loading config...</>;

  // MSAL configuration
  const configuration: Configuration = { ...config.msalConfig };

  const pca = new PublicClientApplication(configuration);

  console.log("Inside App.tsx before returning pca instance", configuration, " >>>> ", pca);
  return <MsalProvider instance={pca}>{props.children}</MsalProvider>;
};


export const Main = () => {
  const { accounts, instance } = useMsal();
  const dispatch = useAppDispatch();
  const userdetailsdata = useAppSelector((state) => state.userContextDetails.loading);
  useEffect(() => {
    if (accounts && accounts.length > 0) {
      const account = accounts[0];
      instance.setActiveAccount(account);
    }
  }, [])
  useEffect(() => {
    dispatch(getUserData());
  }, []);

  const router = createBrowserRouter([
    {
      element: (
          <Header />
      ),
      errorElement: (
        <>
          <h1>Error 404 - Page Not Found</h1>
        </>
      ),
      children: [
        {
          path: "/",
          element: <Navigate to={"/lease"} />
        },
        {
          path: "/lease",
          caseSensitive: false,
          element: <DashboardDataGrid /> 
        },
        {
          path: "/lease/form/:formtype/:itemid",
          element: <LeaseForm />,
          caseSensitive: false
        },
        {
          path: "/lease/form/:formtype",
          element: <LeaseForm />,
          caseSensitive: false
        },
        {
          path: "/config/rawdata",
          caseSensitive: false,
          element: <Rawdata/>
        },
        {
          path: "/config/user/list",
          caseSensitive: false,
          element: <UserRoleMapDashboard/>
        },
        {
          path: "/config/user/new",
          caseSensitive: false,
          element: <UserRoleMapForm/>
        },
        {
          path: "/config/user/:mode/:id",
          caseSensitive: false,
          element: <UserRoleMapForm/>
        },
      ],
    },
  ]);

  return (
    <div >
      <React.Fragment>
        <SessionTimeoutPopup />
        {!userdetailsdata &&
          <RouterProvider router={router} />}
      </React.Fragment>
      <Footer />
    </div>
  );
};

function App() {

  function ErrorComponent({ error }: { error: any }) {
    //return error accordingly
    if (error) {
      return <p>An error occurred: {error.message}</p>;
    }
    return null;
  }


  function LoadingComponent() {
    return <p>Authentication in progress...</p>;
  }

  return (
    <AuthProvider>

      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        errorComponent={ErrorComponent}
        loadingComponent={LoadingComponent}
      >
        <Main />
      </MsalAuthenticationTemplate>
    </AuthProvider>
  );
}

export default App;
